import { Button, InputGroup } from '@blueprintjs/core';
import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { FiArrowLeft } from 'react-icons/fi';

import { SignIn as ContextSignIn } from '../../Context';
import { Logon } from '../../Services/Controllers';
import { NotificacaoInterna } from '../../Services/Notification';
import Logo from '../../Assets/Images/SingIn/Logo.png'

import { Container, Form, Checkbox1 } from './style';
import viewModel from './viewModel';
import Email from '../../Themes/TextFormat/Email';
import apiAdonis from '../../Services/adonis';

const View: React.FC<viewModel> = (viewModel) => {
    /* #region  Variáveis  */
    const [getLogin, setLogin] = useState<string>("");
    const [getLoginEfetuado, setLoginEfetuado] = useState<{ Progresso?: number, Resultado?: boolean }>({ Progresso: undefined, Resultado: undefined });
    const History = useHistory();
    /* #endregion */

    /* #region  Funções  */

    async function EsqueciMinhaSenha(): Promise<void> {
        if (!Email.TextoValido(getLogin)) {
            NotificacaoInterna.ExibirNotificacao("Email inválido!", "Verifique se o email digitado é válido. Este passo é necessário para resetar a sua senha", NotificacaoInterna.TipoDeNotificacao.Alerta);
            return;
        }
        if(Email.TextoValido(getLogin)) {
            try {
                await apiAdonis.post('/rememberPassword', {
                    email: getLogin
                }).then(async (results:any) => await NotificacaoInterna.ExibirNotificacao("Confirmação necessária!", `Um email de confirmação foi enviado para o endereço ${results.data.email}`, NotificacaoInterna.TipoDeNotificacao.Sucesso))
            }
            catch(e) {
                NotificacaoInterna.ExibirNotificacao("Email não existe!", "Verifique se o email digitado é válido.", NotificacaoInterna.TipoDeNotificacao.Erro);
            }

        }
        else {
            NotificacaoInterna.ExibirNotificacao("Caro usuário", "Houve um erro ao tentar alterar a sua senha em nosso sistema, por favor, tente novamente mais tarde!", NotificacaoInterna.TipoDeNotificacao.Erro);
        }
    };

    useEffect(() => {
        async function componentDidMount() {}
        componentDidMount();
    }, []);

    return (
        <Container>
            <Form>
                <img src={Logo} alt="Logo One+" width="200px" />
                <h2>Analytics</h2>
                <h1>Recuperação de senha</h1>
                <h6>Insira seu email e enviaremos um link com mais informações sobre como recuperar sua senha. </h6>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <InputGroup id="Email" placeholder="Email" value={getLogin}
                        onChange={async (event: React.FormEvent<HTMLInputElement>) => await setLogin((event.currentTarget.value))} />
                </div>
                <div>
                    <Button type="submit" intent="primary" onClick={EsqueciMinhaSenha} id="Submit">Enviar</Button>
                </div>
                <a href="/"><FiArrowLeft />Voltar para tela de Login</a>
            </Form>
        </Container>
    );
    /* #endregion */
};

export default View;